module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/271.0cdef17e.png";